// Element lookups, in the two flavours the app actually has.
//
// `$` is for the elements declared in public/index.html. Those are a static
// contract: the call sites have never guarded against them being missing, and if
// one disappears the app is broken, not degraded. So `$` throws, naming the id —
// a clear failure at the lookup instead of "Cannot set properties of null" three
// frames later. dom-contract.test.ts checks every literal id `$` is called with
// against index.html, so a rename fails the test suite rather than a reader's
// page.
//
// `$maybe` is for the elements the app renders itself — the city briefing's
// charts and calendar, the mobile sheet's bucket label. Those are genuinely
// absent until something builds them, and the call sites correctly guard.
// Spelling that difference out is the point: before, one `as T` cast covered
// both, so "this cannot be missing" and "this is usually missing" looked the
// same.

export function $<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`missing element #${id} — public/index.html and the code that reads it have diverged`);
  return el as T;
}

export function $maybe<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}
